import React, { Component } from 'react';
import { Link } from 'react-router-dom';
import { connect } from 'react-redux';
import { Button } from 'reactstrap';
import Page from '~/components/page/page';
import TitleBar from '~/components/titleBar/titleBar';
import CustomerList from '~/containers/customerList/customerList';

export class CustomersPage extends Component {
  render() {
    const createButton = (
      <Link to="/customers/create">
        <Button color="primary">New Customer</Button>
      </Link>
    );
    return (
      <Page>
        <TitleBar icon="users" title="Customers" button={createButton} />
        <CustomerList />
      </Page>
    );
  }
}

export default connect(state => state)(CustomersPage);



// WEBPACK FOOTER //
// ./src/pages/customers/customers.jsx